import { isEmpty, slice } from 'lodash';
import { useGetProducts } from 'src/hooks';
import { mapProductsToGCFGroup } from 'src/utils';

export const useGetTwoLineups = (
  groupNumber: number,
  productCategory?: number[],
) => {
  const { data: allProducts = [] } = useGetProducts(
    !isEmpty(productCategory)
      ? [`product_category_id=${productCategory?.join('|')}`]
      : [],
  );
  const threeLineups = slice(allProducts, 0, 2);

  const gcfGroup = mapProductsToGCFGroup(threeLineups, groupNumber);

  return { gcfGroup };
};
